module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "KEY: STUDENT LEADERSHIP UNIVERSITY CURRICULUM"
    }
  }, [_c('h1', {
    staticClass: "ctl",
    attrs: {
      "id": "d7e5247"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hane_ISBN9781418506001_epub_c5_r1#Anch0777",
      "id": "Anch0764"
    }
  }, [_vm._v("KEY")]), _vm._v(" "), _c('br'), _c('br'), _c('span', {
    staticClass: "mp_2"
  }, [_vm._v("STUDENT "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("LEADERSHIP")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("UNIVERSITY")]), _vm._v(" CURRICULUM")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5377"
    }
  }, [_vm._v("Throughout this study guide, you will see several icons or headings that represent an idea, a statement, or a question that we want you to consider as you experience Scripture in this study guide series. Refer to the descriptions below to help you remember what the icons and headings mean.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e5607"
    }
  }, [_c('b', [_vm._v("transfuse")]), _vm._v(" (trans FYOOZ):to cause to pass from one to another; transmit")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5767"
    }
  }, [_vm._v("The goal of the lesson for the week.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e183",
      "role": "presentation",
      "src": "images/9781418506001_epdf_0007_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e5867"
    }
  }, [_c('b', [_c('em', [_vm._v("Experience Scripture: ")])]), _vm._v("Learning to really experience Scripture is the key element to “getting” who God is and all that He has in store for you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e6037"
    }
  }, [_c('b', [_vm._v("infuse")]), _vm._v(" (in FYOOZ): to cause to be permeated with something (as a principle or quality) that alters usually for the better")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e6197"
    }
  }, [_vm._v("Through journaling, group discussion, and personal study, experience Scripture as it permeates your heart and alters your life.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e6367"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e196",
      "role": "presentation",
      "src": "images/9781418506001_epdf_0007_002.jpg"
    }
  }), _vm._v(" "), _c('b', [_c('em', [_vm._v("Future Tense Living ")])]), _vm._v(": Your choices today will determine your future. Learn how to live with dynamic purpose and influence.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e6587"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e202",
      "role": "presentation",
      "src": "images/9781418506001_epdf_0007_003.jpg"
    }
  }), _vm._v(" "), _c('b', [_c('em', [_vm._v("Attitude Reloaded")])]), _vm._v(": Rethink your attitude! Learn to replace self-centered, negative, or limited thoughts with positive, courageous, compassionate thoughts that are based on God’s unlimited ability and power.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e6838"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e209",
      "role": "presentation",
      "src": "images/9781418506001_epdf_0008_001.jpg"
    }
  }), _vm._v(" "), _c('b', [_c('em', [_vm._v("In His Steps: ")])]), _vm._v("Every attitude and action of your life should begin with the questions, How would Jesus respond to this person and situation before me? What would He choose to do?")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e7038"
    }
  }, [_c('b', [_vm._v("diffuse")]), _vm._v(" (di FYOOZ): to pour out and permit or cause to spread freely; to extend, scatter")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e7248"
    }
  }, [_vm._v("Once God’s Word is infused into your heart, it will pour forth to others without restraint. In this section, explore what that looks like in your daily life.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e7418"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e221",
      "role": "presentation",
      "src": "images/9781418506001_epdf_0008_002.jpg"
    }
  }), _vm._v(" "), _c('b', [_c('em', [_vm._v("Called to Lead")])]), _vm._v(": Learn how to lead others as Christ would.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e7558"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e227",
      "role": "presentation",
      "src": "images/9781418506001_epdf_0008_003.jpg"
    }
  }), _vm._v(" "), _c('b', [_c('em', [_vm._v("Called to Stand")])]), _vm._v(": Know what you believe and learn how to defend it with clarity and strength.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e7708"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e233",
      "role": "presentation",
      "src": "images/9781418506001_epdf_0008_004.jpg"
    }
  }), _vm._v(" "), _c('b', [_c('em', [_vm._v("Called to Share: ")])]), _vm._v("Sharing truth and serving others are results of a transformed life. How can you share with others the awesome things you’re learning?")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "d14e238",
      "role": "presentation",
      "src": "images/9781418506001_epdf_0008_005.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e7898"
    }
  }, [_c('b', [_c('em', [_vm._v("One Thing: ")])]), _vm._v("Consider "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("ONE")]), _vm._v(" THING you can do this week to make a difference in your life and/or the life of another.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e8018"
    }
  }, [_vm._v("[FUSE BOX]")]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e8128"
    }
  }, [_vm._v("Power up for the week with this focused truth.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb8eb1ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hane_ISBN9781418506001_epub_c8_r1.vue
// module id = 72
// module chunks = 0